import { ObservableMap } from 'owa-mobx4-adapter';
import { createStore } from 'satcheljs';
var composeLinkViewStore = {
    composeLinks: new ObservableMap({}),
};
export var getStore = createStore('composeLinkViewStore', composeLinkViewStore);
export default getStore;
//# sourceMappingURL=store.js.map